import React from 'react';
import { motion } from 'framer-motion';
import { Box } from '@mui/material';

// Animated shield: pulsing concentric rings + shield outline + drifting checkmark spark.
// Pure SVG + framer-motion so we don't ship a Lottie runtime + JSON.
export default function AnimatedShield({ size = 140 }) {
  return (
    <Box
      sx={{
        width: size,
        height: size,
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {/* Ambient rings that pulse outward */}
      {[0, 1, 2].map((i) => (
        <motion.div
          key={i}
          style={{
            position: 'absolute',
            inset: 0,
            borderRadius: '50%',
            border: '1px solid rgba(255,255,255,0.14)',
          }}
          initial={{ scale: 0.6, opacity: 0 }}
          animate={{ scale: 1.15, opacity: [0, 0.7, 0] }}
          transition={{
            duration: 3,
            delay: i * 1,
            repeat: Infinity,
            ease: 'easeOut',
          }}
        />
      ))}

      <svg
        width={size * 0.7}
        height={size * 0.7}
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ position: 'relative', zIndex: 1 }}
      >
        <defs>
          <linearGradient id="shieldFill" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="rgba(255,255,255,0.10)" />
            <stop offset="100%" stopColor="rgba(255,255,255,0.02)" />
          </linearGradient>
        </defs>

        {/* Shield body */}
        <motion.path
          d="M50 8 L86 22 L86 52 C86 72 70 88 50 94 C30 88 14 72 14 52 L14 22 Z"
          fill="url(#shieldFill)"
          stroke="rgba(255,255,255,0.85)"
          strokeWidth="1.6"
          initial={{ opacity: 0, y: 6 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        />

        {/* Checkmark inside */}
        <motion.path
          d="M34 52 L46 64 L68 40"
          stroke="#ffffff"
          strokeWidth="3.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
          initial={{ pathLength: 0, opacity: 0 }}
          animate={{ pathLength: 1, opacity: 1 }}
          transition={{ duration: 1.1, delay: 0.4, ease: 'easeInOut' }}
        />
      </svg>
    </Box>
  );
}
